import { BuildCircle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { FC } from "react";

interface IToolInfo {
    name?: string | null
}
const ToolInfo: FC<IToolInfo> = ({ name }) => {
    
    return <Box sx={{ display: "flex", justifyContent: "end", width: "100%", alignItems: "center", color: "text.secondary" , minHeight: "1em"}}>
        {
            name && (
                <>
                    <BuildCircle fontSize="inherit" />
                    <Typography variant="h6" sx={{ mr: 2, ml: 0.5 }}>{name}</Typography>
                </>
            )
        }
    </Box>
}

export default ToolInfo